import Api from '@api/kong_kong/CardAddApi'
import { Select } from 'hljd'
import React, { Component } from 'react'
const { Option } = Select

class Planner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: []
    }
  }
  async componentDidMount() {
    if (this.props.type == 'planner') {
      const { data } = await Api.getPlanner()
      this.setState({
        list: data
      })
    } else {
      const { data } = await Api.getPhotographers()
      this.setState({
        list: data
      })
    }
  }
  render() {
    const { list } = this.state
    const { value, onChange } = this.props
    return (
      <Select
        placeholder="请选择"
        style={{ width: 440 }}
        value={value}
        onChange={v => onChange(v)}
      >
        {list.map(item => {
          return (
            <Option key={item.id} value={item.id}>
              {item.name}
            </Option>
          )
        })}
      </Select>
    )
  }
}

export default Planner
